import React from "react";

import { Box, Card, CircularProgress, Typography } from "@mui/material";

interface StatisticalCardProps {
	title?: string;
	value?: any;
	bottomText?: any;
	isLoading?: boolean;
}

const StatisticalCard: React.FC<StatisticalCardProps> = ({
	title,
	value,
	bottomText,
	isLoading
}) => {
	return (
		<>
			<Card
				style={{
					backgroundColor: "#FFF",
					borderRadius: 16,
					padding: 24,
					boxShadow: "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px"
				}}
			>
				{isLoading !== undefined && isLoading === true ? <>
					<Box style={{textAlign: 'center'}}>
						<CircularProgress size={96} style={{}} />
					</Box>
				</> : <>
					<Typography
						component={"h4"}
						variant={"body1"}
						style={{
							fontWeight: '600'
						}}
					>
						{title ?? ""}
					</Typography>
					<Typography
						component={"h3"}
						variant={"h3"}
						style={{
							fontWeight: '600'
						}}
					>
						{value ?? ""}
					</Typography>
					<Typography
						component={"span"}
						variant={"caption"}
						style={{
							fontWeight: '400',
							color: '#637381'
						}}
					>
						{bottomText ?? ""}
					</Typography>
				</>}
				
			</Card>
		</>
	);
}

export default StatisticalCard;